import { lazy, Suspense } from 'react'
import { LoadingMessage } from './loading-message'

const MonacoEditor = lazy(() => import('@monaco-editor/react'))

type LazyMonacoEditorProps = {
  height?: string
  defaultLanguage?: string
  value?: string
  onChange?: (value: string | undefined) => void
  theme?: string
  options?: Record<string, unknown>
  onMount?: (editor: unknown, monaco: unknown) => void
  'data-testid'?: string
}

export const LazyMonacoEditor = (props: LazyMonacoEditorProps) => {
  return (
    <Suspense
      fallback={
        <div className="flex items-center justify-center h-[120px] border bg-muted/20 rounded">
          <LoadingMessage size="sm" />
        </div>
      }
    >
      <MonacoEditor {...props} />
    </Suspense>
  )
}
